var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-page"},[_c('section',{staticClass:"dashboard-banner"},[_c('h1',{staticClass:"dashboard-title"},[_vm._v(_vm._s(_vm.getStoreTradeName))]),_c('IncomeList'),_c('InstallPwaButton'),_c('section',{staticClass:"dashboard-container pt-4"},[_c('DashboardAlert')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }